import { gql } from "@apollo/client";

export const GET_EXTERNAL_VEHICLE_SCHEDULES_BY_DATE = gql`
  query externalVehicleEvents(
    $startDate: String!
    $endDate: String!
    $limit: Int!
    $offset: Int!
    $status: String!
    $vehicleGroupId: String
    $searchText: String
    $filterType: String
    $filterStatus: String
  ) {
    externalVehicleEvents(
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      offset: $offset
      status: $status
      vehicleGroupId: $vehicleGroupId
      searchText: $searchText
      filterType: $filterType
      filterStatus: $filterStatus
    ) {
      id
      imageUrl
      bodyType
      licencePlate
      make
      model
      year
      status
      pcoNumber
      currentServiceLocation {
        id
        name
      }
      bookingSchedules {
        id
        vehicleGroup
        vehicleStatus
        tba
        booking {
          id
          longTermBooking
          customer {
            firstName
            lastName
          }
          businessCustomer {
            id
            businessName
          }
          rateTypeName
          rateTypeDuration
          currentBookingSchedules {
            id
          }
          referenceNumber
          pickupDateTime
          dropoffDateTime
          customerType
          status
          organisationId
          branchId
          pickupServiceLocation {
            id
            name
          }
          bookingCategory
        }
        startDate
        endDate
        vehicle {
          id
        }
      }
      services {
        id
        status
        startDate
        endDate
        completionDate
        serviceType
        branchId
      }
      holds {
        id
        startDate
        endDate
      }
      branchId
      currentBranchId
    }
  }
`;
